// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "waiting-2Vbdu";
var _3 = "icon-3Qm8i";
export { _1 as "__esModule", _2 as "waiting", _3 as "icon" }
export default { "__esModule": _1, "waiting": _2, "icon": _3 }
